import { render, staticRenderFns } from "./OsappModelViewContentBlockForm.vue?vue&type=template&id=39cea44a&"
import script from "./OsappModelViewContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./OsappModelViewContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports